export default "__VITE_PUBLIC_ASSET__3a976c5b__"